<!-- Global action toasts (not SignalR). Hosted at app root so login and dialogs can show them. -->
<lib-alert-toast-stack></lib-alert-toast-stack>


<!-- Auth Routes - No sidebar/topbar wrapper -->
<div *ngIf="isAuthRoute" class="auth-route-container">
  <router-outlet></router-outlet>
</div>

<!-- Reconnecting banner (SignalR retrying) -->
<div
  *ngIf="!isAuthRoute && isAuthenticated && (connectionStatus$ | async) === 'reconnecting'"
  class="signalr-reconnecting-banner"
  role="status"
  aria-live="polite"
>
  Connection lost - reconnecting…
</div>

<!-- Session held but not confirmed (server unreachable at startup): keep the shell, retry -->
<div *ngIf="sessionUnresolved" class="session-unresolved-banner" role="alert" aria-live="assertive">
  <span>Can't reach the server to confirm your session — retrying automatically.</span>
  <button type="button" class="session-unresolved-retry" (click)="retrySessionInit()">Retry now</button>
</div>

<!-- SignalR connection lost overlay: block usage until reload -->
<div
  *ngIf="!isAuthRoute && isAuthenticated && (connectionLost$ | async)"
  class="signalr-connection-lost-overlay"
  role="alert"
  aria-live="assertive"
>
  <div class="signalr-connection-lost-card">
    <mat-icon class="signalr-error-icon">cloud_off</mat-icon>
    <h2 class="signalr-connection-lost-title">Connection lost</h2>
    <p class="signalr-connection-lost-message">
      The connection to the server was lost. Please reload the page to continue.
    </p>
    <button mat-flat-button color="primary" (click)="reloadPage()" type="button">
      Reload page
    </button>
  </div>
</div>

<!-- Main App Layout - Only show when NOT on auth routes -->
<mat-sidenav-container *ngIf="!isAuthRoute" class="sidenav-container" [@.disabled]="true">
  <!-- Sidebar - Only show when authenticated -->
  <mat-sidenav
    *ngIf="isAuthenticated"
    #sidenav
    [mode]="isMobile ? 'over' : 'side'"
    [(opened)]="sidebarOpened"
    class="sidenav"
    fixedInViewport="true"
    [disableClose]="!isMobile"
    [@.disabled]="true"
  >
    <app-sidebar></app-sidebar>
  </mat-sidenav>

  <!-- Main Content -->
  <mat-sidenav-content [@.disabled]="true">
    <!-- Topbar -->
    <header class="topbar" *ngIf="isAuthenticated">
      <button
        mat-icon-button
        class="menu-toggle"
        (click)="toggleSidebar()"
        aria-label="Toggle sidebar"
        type="button"
      >
        <mat-icon>menu</mat-icon>
      </button>

      <div class="topbar-content" *ngIf="pageInfo$ | async as pageInfo; else defaultTitle">
        <div class="page-header-block">
          <div class="header-icon" *ngIf="pageInfo.icon || pageInfo.iconUrl">
            <img *ngIf="pageInfo.iconUrl" [src]="pageInfo.iconUrl" alt="" class="custom-header-icon" />
            <i-lucide *ngIf="!pageInfo.iconUrl && pageInfo.icon" [name]="pageInfo.icon" [size]="24"></i-lucide>
          </div>
          <div class="header-content">
            <h1 class="page-title">{{ pageInfo.title }}</h1>
            <p class="page-subtitle" *ngIf="pageInfo.subtitle">{{ pageInfo.subtitle }}</p>
          </div>
        </div>
      </div>
      <ng-template #defaultTitle>
        <div class="topbar-content">
          <h1 class="page-title">{{ getPageTitle() }}</h1>
        </div>
      </ng-template>

      <button
        *ngIf="currentMarina$ | async as currentMarina"
        class="current-marina-badge"
        [class.clickable]="currentMarina.canSwitch"
        [disabled]="!currentMarina.canSwitch"
        (click)="onCurrentMarinaClick()"
        type="button"
      >
        <span class="marina-name">{{ currentMarina.name }}</span>
      </button>

      <!-- Notifications + User menu -->
      <marina-topbar-notifications
        [items]="(notificationItems$ | async) ?? []"
        [unreadCount]="(notificationUnreadCount$ | async) ?? 0"
        [loading]="(notificationLoading$ | async) ?? false"
        [enableToasts]="true"
        [incomingToast]="notificationToast$ | async"
        (openMenu)="onNotificationsMenuOpen()"
        (itemClick)="onNotificationItemClick($event)"
        (toastClick)="onNotificationToastClick($event)"
        (markAllRead)="onNotificationMarkAllRead()"
      ></marina-topbar-notifications>
      <marina-topbar-user-menu
        [currentUser$]="currentUser$"
        (logout)="logout()"
      ></marina-topbar-user-menu>
    </header>

    <!-- Main Content Area -->
    <main class="main-content">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
